import ErrorBoundary from '@shared/components/ErrorBoundary';
import React, { lazy } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

const Modal = lazy(() => import('./shared/components/modal/Modal'));
const NotificationContainer = lazy(
  () => import('./shared/status/components/NotificationContainer'),
);

const App: React.FC = () => {
  const location = useLocation();
  return (
    <ErrorBoundary key={location.key}>
      <Modal />
      <NotificationContainer />
      <Outlet />
    </ErrorBoundary>
  );
};

export default App;
